import React, { Component } from 'react';
import {Button} from 'reactstrap';
import find from 'lodash/find';
import {capitalizeFirstLetter} from './../../../utils/stringUtils';
import { isNumber } from 'util';
import moment from 'moment';

class ManualEntryModal extends Component {
  
  showAnswer = (answer) => {
    // console.log(answer);
    if( (answer && answer.length === 0)|| !answer) {
      return `No`;
    }
    if(isNaN(answer)) {
      return capitalizeFirstLetter(answer);
    }
    return `${answer}%`;
  }

  render() { 
    const {questionAnswer,clickedPoint} = this.props;
    const {score} = questionAnswer;
    // console.log(clickedPoint);
    // console.log(questionAnswer);
    const {points} = clickedPoint;
    const point = points[0];
    const kpiId = point.data.id;
    const {x} = point;
    const selectedKpi = find(questionAnswer,(o) => {
      if(o.kpiId._id === kpiId) {
        return o;
      }
    });
    console.log('x point: ', x);
    const scores = find(selectedKpi.score,(o) => { 
      // console.log(o);
      const date = x + "T00:00:00.000Z";
      if(date === o.date) {
        return o;
      }
    });
    // console.log(scores);
    return ( 
      <div className="qa-modal viewSingleChartPrPModal" >
        <div className="title">{selectedKpi.kpiId.name}</div>{x?<span className="manualEntryDate"> as of {moment(x).format('MMMM D, YYYY')} </span>:null}
        <div className="manualEntryModalContents">
          {
            scores && scores.results ?
            scores.results.map((o, idx) => {
              return(
                <div key={o._id} className={idx==0?"": "singleChartPRPcontainer"}>
                  <div className="question">{o.text}</div>
                  <div className="answer mt5 ml10">{this.showAnswer(o.value)}</div>
                </div>
              )
            }) : null
          }
        </div>
        <div className="mt10">
          <Button onClick={this.props.toggle} color="secondary-filled" style={{width:'25%'}}>
            <span style={{fontSize:'18px',lineHeight:'25px'}}>Close</span>
          </Button>
        </div>
      </div>
    );
  }
}
 
export default ManualEntryModal;